// extracted by mini-css-extract-plugin
export default {"unique":"Unique_unique__e0SpV","points":"Unique_points__Ns3HZ"};